export default {

  methods: {
    
    _validarPermiso() {
      return true;
    },

    getTitleSectionByLink(link) {
      if (link === 'sections') return 'Secciones'
      if (link === 'columns') return 'Columnas'
      if (link === 'inventory-sections') return 'Configurar tipos de reporte'
    }
    
  },

};